export default __webpack_public_path__ + "static/media/soudan.47286879.png";